import { Component } from '@angular/core';
import { ViewController, NavParams } from "ionic-angular";
@Component({
  selector: 'page-confirmLogout',
  templateUrl: 'confirmLogout.html',
})
export class ConfirmLogout {
  testo: string;
  num:any;
  constructor(public viewCtrl: ViewController, public navpar:NavParams) {
    this.testo = this.navpar.get('testo');
    this.num = this.navpar.get('num');
  }

  response(res){
    this.viewCtrl.dismiss(res);
  }
}


// WEBPACK FOOTER //
// ./src/pages/confirmLogout/confirmLogout.ts